<template>
  <vs-popup
      fullscreen
      :active.sync="isActive"
      title="Generar pagos a instalador">
    <div>
      <vs-button
          class="mt-5"
          :disabled="getTotalPercentage() !== 100"
          @click="generatePaymentButtonHandler()">
        Crear estructura de pagos
      </vs-button>
      <!-- print supplier payment templates -->
      <vs-select
          v-model="templateSelected"
          @change="paymentTemplateSelectHandler(templateSelected)"
          label="Template de pagos"
          class="float-right mb-5">
        <vs-select-item
            v-for="(template, index) in paymentTemplates"
            :key="index"
            :value="template.id"
            :text="template.name"></vs-select-item>
      </vs-select>
    </div>
    <div class="clearfix"></div>

    <div class="row">
      <div class="col-md-3">
        <slot></slot>
      </div>
      <div class="col-md-8 offset-md-1">
        <span class="p-5 font-bold mb-5">
          Total de la factura: {{ this.project.dispersionAmount | currency }}
        </span>

        <table class="table">
          <tr>
            <td>¿Cobra comisiones?</td>
            <td>Porcentaje de pago</td>
            <td>Monto</td>
            <td v-if="!project.isApplicantLoan()">% Comisión</td>
            <td v-if="!project.isApplicantLoan()">Monto Comisión</td>
            <td>Total</td>
          </tr>
          <tr v-for="(payment, index) of payments" :key="index">
            <td>
              <vs-checkbox
                  v-model="payment.hasFee"
                  @change.prevent="checkboxHandler(payment)" />
            </td>
            <td>
              <vs-input type="number" v-model="payment.paymentPercentage" placeholder="% de Pago"></vs-input>
            </td>
            <td>
              {{ payment.getRealAmount() | currency }}
            </td>
            <td v-if="!project.isApplicantLoan()">
              {{ payment.impactaMasCommission.toFixed(2) }}
            </td>
            <td v-if="!project.isApplicantLoan()">
              {{ payment.getSupplierCommission() | currency }}
            </td>
            <td>
              {{ payment.getAmount() | currency }}
            </td>
          </tr>
          <tr class="bg-black text-white">
            <td>TOTALES</td>
            <td>{{ getTotalPercentage().toFixed(2) }} %</td>
            <td>{{ getTotalRealPaymentAmount() | currency }}</td>
            <td v-if="!project.isApplicantLoan()">{{ this.impactaMasSupplierCommission.toFixed(2) }}</td>
            <td v-if="!project.isApplicantLoan()">{{ getTotalSupplierCommission() | currency }}</td>
            <td>{{ project.profile.payments.totalAmount | currency }}</td>
          </tr>
        </table>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import {LoanProject} from "@/models/LoanPayment/Project";
import * as loanPaymentTemplates from "@/dbjson/payment-template.json"
import _ from "lodash";

export default {
  name: "generate-loan-payment-dialog",
  props: {
    project: {
      type: LoanProject,
      required: true
    },
    regenerate: {
      type: Boolean,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    },
  },
  data: () => ({
    templateSelected: 2,
    paymentTemplates: [],
    payments: [],
    impactaMasSupplierCommission: 0,
  }),
  computed: {
    isActive: {
      get: function () {
        return this.active
      },
      set: function (value) {
        this.$emit('update:active', value)
      }
    }
  },
  mounted() {
    if (this.project.isApplicantLoan()) {
      this.templateSelected = 1;
    }

    this.paymentTemplates = loanPaymentTemplates.payments;
    this.setPaymentTemplateDefault()
  },
  methods: {
    async generatePaymentButtonHandler() {
      let requestParams = this.payments.map((payment) => {
        return {
          has_fee: payment.hasFee,
          percentage: payment.paymentPercentage,
          fee_percentage: this.project.isApplicantLoan() ? 0 : payment.impactaMasCommission
        }
      });

      this.$vs.loading();
      try {
        let baseUri = '/api/loan-payment';
        const {data} = await axios.post(`${baseUri}/${this.project.id}`, {
          payments: requestParams,
          regenerate: this.regenerate
        })

        this.$vs.loading.close();
        this.$emit("onSuccess", data)
        await swal("Notificación", "Los pagos se generaron correctamente.", "success")
      } catch (e) {
        this.$vs.loading.close();
        this.$emit("onError", e.response.data.error)

        if (e.response.status === 422) {
          await swal("Error", e.response.data.error, "warning")
        }
      }
    },
    paymentTemplateSelectHandler(template) {
      let selectedPaymentEntity = this.paymentTemplates.filter(t => t.id === template)
      if (selectedPaymentEntity.length > 0) {
        this.payments = this.parsePaymentCollection(selectedPaymentEntity[0].template);
      }
    },
    setPaymentTemplateDefault() {
      this.payments = this.parsePaymentCollection(this.paymentTemplates[1].template);
    },
    parsePaymentCollection(paymentsRaw) {
      return paymentsRaw.map((payment) => {
        let realFundingCommission = this.project.isApplicantLoan() ? 0 : this.project.fundingCommissionFee;

        return new Payment(
            this.project.dispersionAmount,
            payment.hasCommission ? realFundingCommission : 0,
            payment.paymentPercentage,
            this.project.isApplicantLoan(),
            payment.hasCommission
        )
      })
    },
    getTotalAmount() {
      return _.sumBy(this.payments, payment => {
        return parseFloat(payment.getAmount())
      });
    },
    getTotalSupplierCommission() {
      return _.sumBy(this.payments, payment => {
        return parseFloat(payment.getSupplierCommission())
      });
    },
    getTotalPercentage() {
      return _.sumBy(this.payments, payment => {
        return parseFloat(payment.paymentPercentage)
      });
    },
    getTotalRealPaymentAmount() {
      return _.sumBy(this.payments, payment => {
        return parseFloat(payment.getRealAmount())
      });
    },
    checkboxHandler(payment) {
      let paymentsWithCommission = this.payments
          .filter((payment) => {
            return payment.hasCommission();
          })

      if (paymentsWithCommission.length > 0) {
        for (let currentPayment of paymentsWithCommission) {
          currentPayment.changeSupplierFundingCommission(0, false);
        }
      }
      payment.changeSupplierFundingCommission(this.project.fundingCommissionFee, true);
    }
  }
}

class Payment {
  /**
   *
   * @param {number} totalCost
   * @param {number} impactaMasCommission
   * @param {number} paymentPercentage
   * @param {boolean} isApplicantLoan
   * @param {boolean} hasFee
   */
  constructor(
      totalCost,
      impactaMasCommission,
      paymentPercentage,
      isApplicantLoan,
      hasFee
  ) {
    this.totalCost = totalCost;
    this.impactaMasCommission = impactaMasCommission;
    this.paymentPercentage = paymentPercentage;
    this.hasFee = hasFee;
    this.isApplicantLoan = isApplicantLoan;
  }

  changeSupplierFundingCommission(commission, hasFee) {
    this.impactaMasCommission = commission;
    this.hasFee = hasFee;
  }

  getAmount() {
    return this.totalCost * (this.paymentPercentage / 100);
  }

  getSupplierCommission() {
    return this.totalCost * (this.impactaMasCommission / 100);
  }

  getRealAmount() {
    if (this.isApplicantLoan) {
      return this.getAmount();
    }
    return this.getAmount() - this.getSupplierCommission();
  }

  hasCommission() {
    return this.hasFee;
  }
}
</script>

<style scoped>

</style>
